import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import axios from "axios";
import {toast} from "react-toastify";
import {uploadToServer} from "../helpers/FIleHelper";
import _ from "lodash";
import CreateEditCustomerModal from "./CreateEditCustomerModal";
import CreateEditSiteModal from "./CreateEditSiteModal";
import Input from "../components/forms/Input";
import Button from "../components/Button";

const JOB_DEFAULTS = {
    customer_id:    "",
    site_id:        "",
    name:           "",
}

const DuplicateJobModal = (props) => {
    const {
        jobId       = null,
        show        = false,
        parentId    = "",
        disabled    = false,
        onCancel    = () => {},
        onComplete  = (job) => {},
        id          = "duplicate-job-modal",
    } = props;

    const [submitting, setSubmitting]   = useState(false);
    const [customers, setCustomers]     = useState([]);
    const [sites, setSites]             = useState([]);
    const [oldJob, setOldJob]           = useState(JOB_DEFAULTS);
    const [newJob, setNewJob]           = useState(JOB_DEFAULTS);
    const [errors, setErrors]           = useState(null);

    const [createCustomerModal, setCreateCustomerModal] = useState(false);
    const [createSiteModal, setCreateSiteModal]         = useState(false);

    useEffect(() => {
        load(false);
    }, [jobId]);

    const load = (selectsOnly) => {
        axios.get(route('web-api.job.config', {job_id: jobId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.customers) {
                        setCustomers(response.data.customers);
                    }

                    if (!!response.data.sites) {
                        setSites(response.data.sites);
                    }

                    if (selectsOnly === false) {
                        if (!!response.data.job) {
                            setOldJob(response.data.job);
                            setNewJob(response.data.job);
                        }
                    }
                }
            })
            .catch((error) => {
                toast.error(<div>{"An error occurred"}</div>);
                setSubmitting(false);
            });
    }

    useEffect(() => {
        if (!!submitting) {
            submit();
        }
    }, [submitting]);

    const reset = () => {
        setOldJob(JOB_DEFAULTS);
        setNewJob(JOB_DEFAULTS);

        setSubmitting(false);
        setErrors(null);
    }

    const payload = () => {
        return {
            method: 'post',
            url:    route('web-api.job.duplicate', {job: jobId}).toString(),
            data:   {
                old_job_id:     jobId,
                customer_id:    newJob.customer_id,
                site_id:        newJob.site_id,
            },
        }
    }

    const submit = () => {
        axios(payload())
            .then((response) => {
                reset();
                onComplete(response.data.job_id);
            })
            .catch((error) => {
                console.log(error);
                if (!!error.response.data && !!error.response.data.errors) {
                    setErrors(error.response.data.errors);
                    toast.error(<div>{!!error.response.data.message ? error.response.data.message : "An error occurred"}</div>);
                }

                setSubmitting(false);
            });
    }

    const handleClose = () => {
        if (!submitting) {
            reset();
            onCancel();
        }
    }

    const onChange = (field, value) => {
        const clone = _.cloneDeep(newJob);

        switch (field) {
            case 'customer_id':
                clone.customer_id   = value;
                clone.site_id       = JOB_DEFAULTS.site_id;
                break;
            default:
                clone[field] = value;
                break;
        }

        setNewJob(clone);
    }

    const getCustomerName = (customerId) => {
        for (let i = 0; i < customers.length; i++) {
            if (parseInt(customerId) === parseInt(customers[i].value)) {
                return customers[i].label;
            }
        }

        return "-";
    }

    const getSiteName = (siteId) => {
        for (let i = 0; i < sites.length; i++) {
            if (parseInt(siteId) === parseInt(sites[i].value)) {
                return sites[i].label;
            }
        }

        return "-";
    }

    const handleCustomerCreation = (customer) => {
        load(true);
        onChange('customer_id', customer);
        setCreateCustomerModal(false);
    }

    const handleSiteCreation = (site) => {
        load(true);
        onChange('site_id', site);
        setCreateSiteModal(false);
    }

    let selectableSites = [];
    if (!!newJob.customer_id && newJob.customer_id !== "" && !!sites) {
        selectableSites = sites.filter((site) => {
            return site.customer_id === newJob.customer_id;
        })
    }

    let sitePlaceholder = "Select";
    if (!newJob.customer_id || newJob.customerId === "") {
        sitePlaceholder = "Select A Customer";
    } else if (!selectableSites || selectableSites.length === 0) {
        sitePlaceholder = "No Sites"
    }

    return (
        <React.Fragment>
            <Modal
                ariaHideApp={false}
                isOpen={show}
                parentSelector={() => document.getElementById(parentId)}
                onRequestClose={() => handleClose()}
                contentLabel={"Duplicate Job"}
                className={'ReactModal__Content react-modal-outer modal-dialog admin-modal wide-modal allow-overflow'}
                style={{
                    overlay: {
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        overflow: 'hidden',
                        outline: 'none',
                    },
                    content: {
                        width: "100%",
                        height: "100%",
                        padding: 0,
                        border: 0,
                        outline: 'none',
                    },
                }}
            >
                <div className="p-4 modal-content" id={id}>
                    <div className="modal-header border-0 m-0 p-0 pb-4">
                        <h4 className="modal-title text-eh-navy">{"Duplicate Job"}</h4>
                        <button
                            type="button" className="close"
                            data-dismiss="modal" aria-label="Close"
                            onClick={() => handleClose()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body m-0 mb-3 p-0">
                        <div className="border-bottom mb-3">
                            <div className="row m-0 p-0">
                                <div className="col-12 col-md-6 m-0 p-0 pr-md-2">
                                    <p className="mb-0 text-eh-off-black"><strong>Old Job Name</strong></p>
                                    <p className="text-eh-off-black">{!!oldJob && !!oldJob.name ? oldJob.name : "-"}</p>
                                </div>
                            </div>
                            <div className="row m-0 p-0">
                                <div className="col-12 col-md-6 m-0 p-0 pr-md-2">
                                    <p className="mb-0 text-eh-off-black"><strong>Old Job Customer</strong></p>
                                    <p className="text-eh-off-black">{!!oldJob && !!oldJob.customer_id ? getCustomerName(oldJob.customer_id) : "-"}</p>
                                </div>
                                <div className="col-12 col-md-6 m-0 p-0 pl-md-2">
                                    <p className="mb-0 text-eh-off-black"><strong>Old Job Site</strong></p>
                                    <p className="text-eh-off-black">{!!oldJob && !!oldJob.site_id ? getSiteName(oldJob.site_id) : "-"}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row m-0 p-0">
                            <div className="col-12 col-md-6 m-0 p-0 pr-md-2 bespoke-input">
                                <Input
                                    name={"customer_id"}
                                    label={"Customer"}
                                    required={true}
                                    type={"searchable-select"}
                                    value={newJob.customer_id}
                                    options={customers}
                                    placeholder={"Select"}
                                    disabled={!customers || customers.length < 1 || submitting}
                                    onChange={(value) => onChange("customer_id", value)}
                                    error={!!errors && !!errors.customer_id ? errors.customer_id : null}
                                />
                                <Button
                                    onClick={() => setCreateCustomerModal(true)}
                                    label={"Create New Customer"}
                                    icon={"far fa-plus-circle"}
                                    classes={"btn btn-eh-lilac m-0 mb-3"}
                                />
                            </div>
                            <div className="col-12 col-md-6 m-0 p-0 pl-md-2 bespoke-input">
                                <Input
                                    name={"site_id"}
                                    label={"Site"}
                                    required={true}
                                    type={"searchable-select"}
                                    value={newJob.site_id}
                                    options={selectableSites}
                                    placeholder={sitePlaceholder}
                                    disabled={!selectableSites || selectableSites.length < 1 || submitting}
                                    onChange={(value) => onChange("site_id", value)}
                                    error={!!errors && !!errors.site_id ? errors.site_id : null}
                                />
                                <Button
                                    onClick={() => setCreateSiteModal(true)}
                                    label={"Create New Site"}
                                    icon={"far fa-plus-circle"}
                                    classes={"btn btn-eh-lilac m-0 mb-3"}
                                    disabled={!newJob.customer_id || newJob.customerId === ""}
                                />
                            </div>
                        </div>
                        <div className="row m-0 p-0">
                            <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center">
                                <div className="d-flex justify-content-start align-items-center">
                                    <Button
                                        onClick={() => setSubmitting(true)}
                                        label={"Duplicate Job"}
                                        classes={"btn btn-eh-lilac m-0 mr-4"}
                                    />
                                    <Button
                                        onClick={() => handleClose()}
                                        label={"Cancel"}
                                        classes={"btn btn-outline-eh-off-black m-0 mr-4"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <CreateEditCustomerModal
                customerId={null}
                show={createCustomerModal}
                parentId={parentId}
                onCancel={() => setCreateCustomerModal(false)}
                onComplete={(customer) => handleCustomerCreation(customer)}
                onDelete={(customer) => {}}
            />
            <CreateEditSiteModal
                siteId={null}
                customerId={newJob.customer_id}
                show={createSiteModal}
                parentId={parentId}
                onCancel={() => setCreateSiteModal(false)}
                onComplete={(site) => handleSiteCreation(site)}
                onDelete={(site) => {}}
            />
        </React.Fragment>
    );
}

export default DuplicateJobModal;
